import React, { memo } from 'react';
import { Box, VStack } from 'native-base';
import { Typography } from '../Typography';
import { DashedCircle } from './DashedCircle';
import { StyleSheet } from 'react-native';
const styles = StyleSheet.create({
  container: {
    justifyContent: 'center',
    alignItems: 'center'
  },
  outer: {
    width: 30,
    height: 30
  },
  inner: {
    width: 24,
    height: 24,
    margin: 2
  }
});
export default /*#__PURE__*/memo(_ref => {
  let {
    step,
    state,
    text
  } = _ref;
  switch (state) {
    case 'InProgress':
      return /*#__PURE__*/React.createElement(VStack, {
        space: "2.5"
      }, /*#__PURE__*/React.createElement(Box, {
        style: styles.container
      }, /*#__PURE__*/React.createElement(DashedCircle, {
        color: "#212121"
      }), /*#__PURE__*/React.createElement(Box, {
        position: "absolute",
        style: [styles.inner, {
          marginLeft: 3
        }],
        rounded: "full",
        justifyContent: "center",
        alignItems: "center",
        bg: "darkGray.500"
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "trackerItem",
        color: "white.500",
        noOfLines: 2
      }, step))), /*#__PURE__*/React.createElement(Typography, {
        variant: "trackerItem",
        color: "darkGray.500",
        textAlign: "center"
      }, text));
    case 'Completed':
      return /*#__PURE__*/React.createElement(VStack, {
        space: "2.5"
      }, /*#__PURE__*/React.createElement(Box, {
        style: styles.container
      }, /*#__PURE__*/React.createElement(Box, {
        style: styles.outer,
        rounded: "full",
        bg: "white.500",
        borderWidth: "1",
        borderColor: "primary.500"
      }, /*#__PURE__*/React.createElement(Box, {
        style: styles.inner,
        rounded: "full",
        justifyContent: "center",
        alignItems: "center",
        bg: "primary.500"
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "trackerItem",
        color: "white.500"
      }, step)))), /*#__PURE__*/React.createElement(Typography, {
        variant: "trackerItem",
        color: "primary.500",
        textAlign: "center"
      }, text));
    case 'InActive':
      return /*#__PURE__*/React.createElement(VStack, {
        space: "2.5",
        alignItems: "center"
      }, /*#__PURE__*/React.createElement(Box, {
        style: styles.container
      }, /*#__PURE__*/React.createElement(Box, {
        style: styles.outer,
        rounded: "full",
        bg: "transparent"
      }, /*#__PURE__*/React.createElement(Box, {
        style: styles.inner,
        rounded: "full",
        justifyContent: "center",
        alignItems: "center",
        bg: "darkGray.200"
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "trackerItem",
        color: "white.500"
      }, step)))), /*#__PURE__*/React.createElement(Typography, {
        variant: "trackerItem",
        color: "darkGray.400",
        textAlign: "center"
      }, text));
  }
});
//# sourceMappingURL=ProgressThumb.js.map